// my-app/src/lib/halalBrands.ts
export interface HalalCertificate {
    number: number;
    url: string;
}

export interface HalalBrandInfo {
    certificates: HalalCertificate[];
    description?: string;
}

export const halalBrands: Record<string, HalalBrandInfo> = {
    "Vita Mine Lab": {
        certificates: [
            { number: 1, url: "https://retail.vitaline.uz/wp-content/certificates/2025%20AVA%20VEGAN%20Certificate%20VITA%20MINE%20LAB%208-2025.pdf" },
            { number: 2, url: "https://retail.vitaline.uz/wp-content/certificates/Halal%20Certificate%20-%20%20VITA%20MINE%20LAB.pdf" },
        ],
    },
    "WeightWorld": {
        certificates: [],
    },
    "Bronson": {
        certificates: [],
    },
};